<script lang="ts">
	import { Responsive } from "responsive"
	import { QuickSelectorRadio } from "misc-ui"
	import { ShowLibraryController } from "../ShowLibraryController"
	import MobileDeviceFilter from "./MobileDeviceFilter.svelte"

	let isHidden = $state(true)
	let isMobile = $derived(Responsive.isMobile)

	let filterOptions = {
		filter: ["Date Created", "Last Modified", "Projector", "Name"],
		order: ["Ascending", "Descending"],
	}

	let filterSelection: { [key in keyof typeof filterOptions]: string } = $state({
		filter: "Last Modified",
		order: "Descending",
	})

	function toggleHidden(e: MouseEvent) {
		e.preventDefault()
		isHidden = !isHidden
	}

	$effect(() => {
		ShowLibraryController.updateFilterOptions(filterSelection)
	})
</script>

<a href="#" onclick={toggleHidden}>
	Filter By
	{#if isMobile}
		<div class="mobile-device-filter">
			<MobileDeviceFilter isOpen={!isHidden} onToggle={(doShow) => (isHidden = !doShow)} />
		</div>
	{:else}
		<QuickSelectorRadio
			bind:selections={filterSelection}
			options={filterOptions}
			defaultSelection={{
				filter: "Last Modified",
				order: "Descending",
			}}
			{isHidden}
			allowClear
		/>
	{/if}
</a>

<style>
	a {
		margin-right: 1rem;
	}

	:global(.isMobile) a {
		margin-right: 0;
		color: var(--color-text);
	}

	.mobile-device-filter {
		position: relative;
	}
</style>
